// this file exists only to be extended on by the Queries and Mutations in the other files
// https://medium.com/@choudlet/how-to-combine-graphql-type-definitions-quickly-and-easily-with-apollo-server-c96c4d9a7ea1
import gql from 'graphql-tag';

export default gql`
  type Query {
    root: String
  }
  type Mutation {
    root: String
  }
`;
